/**
 * @author Mevan Nirosh
 * @version 0.1
 * @since 10/21/2024
 */

import Select from "react-select"
import { FormControl } from "@mui/material"

const LtsAppStatusDropdown = ({ onChange, selectRef, value }) => {
  // Selector
  const customStyles = {
    control: (provided) => ({
      ...provided,
      padding: "10px",
    }),
  }

const options = [
  {
    value: "INSTALL_SUCC",
    label: "Install Success",
  },
  {
    value: "INSTALL_FAIL",
    label: "Install Failed",
  },
  {
    value: "APP_DOWNLOADED",
    label: "App Downloaded",
  },
  {
    value: "UNINSTALL_SUCC",
    label: "Uninstall Success",
  },
  {
    value: "UNINSTALL_FAIL",
    label: "Uninstall Failed",
  },
  {
    value: "EVENT_RECEIVED",
    label: "Event Received",
  },
   {
    value: "FAILED",
    label: "All Except Install Success",
  },
]

  return (
    <div>
      <p
        style={{
          fontSize: "12px",
          position: "relative",
          top: "-10px",
          left: "10px",
          background: "#fff",
          width: "100px",
          paddingLeft: "5px",
          zIndex: 201,
        }}
      >
        Lts. App Status
      </p>
      <FormControl
        sx={{
          minWidth: 400,
          zIndex: 99,
          position: "relative",
          top: "-36px",
          height: 0,
        }}
        size="medium"
      >
        <Select
          ref={selectRef}
          value={options.find((option) => option.value === value)}
          options={options}
          onChange={onChange}
          styles={customStyles}
          isClearable
        />
      </FormControl>
    </div>
  )
}

export default LtsAppStatusDropdown
